/* eslint-disable */
/// @ts-nocheck -- Bulk rename to enable TypeScript validation

import '@mod-publisher/js/richcontent/styling.css';
import './richeditor.scss';
import './internal/buttons.scss';
import './internal/widgets.scss';
